export default [
  {
    id: 1,
    title:
      'Cómo obtener un certificado SSL para el dominio personalizado de tu Centro de ayuda',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Michael' },
    category: {
      slug: 'configuration',
      icon: '📦',
      name: 'Instalación y configuración',
    },
    views: 3400,
  },
  {
    id: 2,
    title: 'Cómo configurar tu primer portal del Centro de ayuda',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'John' },
    category: { slug: 'onboarding', icon: '🧑‍🍳', name: 'Primeros pasos' },
    views: 400,
  },
  {
    id: 3,
    title: 'Buenas prácticas para organizar el contenido de tu Centro de ayuda',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'Fernando' },
    category: { slug: 'best-practices', icon: '⛺️', name: 'Buenas prácticas' },
    views: 400,
  },
  {
    id: 4,
    title: 'Cómo personalizar la apariencia de tu Centro de ayuda',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Jane' },
    category: { slug: 'design', icon: '🎨', name: 'Diseño' },
    views: 400,
  },
  {
    id: 5,
    title: 'Cómo integrar tu Centro de ayuda con herramientas de terceros',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Sarah' },
    category: {
      slug: 'integrations',
      icon: '🔗',
      name: 'Integraciones',
    },
    views: 2800,
  },
  {
    id: 6,
    title: 'Cómo gestionar los permisos de usuario en tu Centro de ayuda',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Alex' },
    category: {
      slug: 'administration',
      icon: '🔐',
      name: 'Administración',
    },
    views: 1200,
  },
  {
    id: 7,
    title: 'Cómo crear y gestionar secciones de preguntas frecuentes',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Emily' },
    category: {
      slug: 'content-management',
      icon: '📝',
      name: 'Gestión de contenido',
    },
    views: 5600,
  },
  {
    id: 8,
    title: 'Cómo implementar la función de búsqueda en tu Centro de ayuda',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'David' },
    category: {
      slug: 'features',
      icon: '🔍',
      name: 'Funciones',
    },
    views: 1800,
  },
  {
    id: 9,
    title: 'Cómo analizar las métricas de uso del Centro de ayuda',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Rachel' },
    category: {
      slug: 'analytics',
      icon: '📊',
      name: 'Analíticas',
    },
    views: 3200,
  },
  {
    id: 10,
    title: 'Cómo configurar el soporte multilingüe en tu Centro de ayuda',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Carlos' },
    category: {
      slug: 'localization',
      icon: '🌍',
      name: 'Localización',
    },
    views: 900,
  },
  {
    id: 11,
    title: 'Cómo crear tutoriales interactivos para tus productos',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Olivia' },
    category: {
      slug: 'education',
      icon: '🎓',
      name: 'Educación',
    },
    views: 4100,
  },
  {
    id: 12,
    title: 'Cómo implementar un sistema de comentarios en tu Centro de ayuda',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Nathan' },
    category: {
      slug: 'user-engagement',
      icon: '💬',
      name: 'Participación de usuarios',
    },
    views: 750,
  },
  {
    id: 13,
    title: 'Cómo optimizar el contenido del Centro de ayuda para SEO',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Sophia' },
    category: {
      slug: 'seo',
      icon: '🚀',
      name: 'SEO',
    },
    views: 2900,
  },
  {
    id: 14,
    title: 'Cómo crear una base de conocimiento para equipos internos',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'Daniel' },
    category: {
      slug: 'internal-resources',
      icon: '🏢',
      name: 'Recursos internos',
    },
    views: 1500,
  },
];
